import { call, put } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as BuscaClienteActions } from "../ducks/buscaCliente";
import { Creators as LoadingActions } from "../ducks/loading";
import moment from "moment";

export function* buscaClienteAction({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(
      api.get,
      `/calls/customers?search=${payload.search}&&page=1&&per_page=99999999999`
    );
    let dataPayload = data.data.map(item => ({
      addresses: item.addresses,
      dead: item.dead,
      blacklisted: item.blacklisted,
      blacklist: item.blacklist,
      birthday: item.birthday,
      calls: item.calls.map(call => ({
        campaign: call.campaign,
        created_at: call.created_at,
        customer_id: call.customer_id,
        finished_at: call.finished_at,
        id: call.id,
        next_call: call.next_call
          ? moment(call.next_call).format("DD/MM/YYYY HH:mm")
          : "NÃO AGENDADO",
        started_at: moment(call.started_at).format("DD/MM/YYYY HH:mm"),
        status: call.status,
        status_color: call.status_color,
        type: call.type,
        updated_at: call.updated_at,
        user_name: call.user_name,
        value: call.value
      })),
      calls_count: item.calls_count,
      contacts: item.contacts,
      cpf_cnpj: item.cpf_cnpj,
      gender: item.gender,
      id: item.id,
      name: `${
        moment(item.birthday).format("DD/MM") === moment().format("DD/MM")
          ? "🎂🎈"
          : ""
      } ${item.name}`,
      photo: item.photo,
      sales_count: item.sales_count
    }));
    yield put(BuscaClienteActions.buscaClienteActionSuccess(dataPayload));
    yield put(BuscaClienteActions.limpaIdCampanha());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* sorteiaCliente({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(
      api.get,
      `/campaigns/${payload.id}/customer/random`
    );
    let dataPayload = data.data.map(item => ({
      addresses: item.addresses,
      dead: item.dead,
      blacklisted: item.blacklisted,
      blacklist: item.blacklist,
      birthday: item.birthday,
      calls: item.calls.map(call => ({
        campaign: call.campaign,
        created_at: call.created_at,
        customer_id: call.customer_id,
        finished_at: call.finished_at,
        id: call.id,
        next_call: call.next_call
          ? moment(call.next_call).format("DD/MM/YYYY HH:mm")
          : "NÃO AGENDADO",
        started_at: moment(call.started_at).format("DD/MM/YYYY HH:mm"),
        status: call.status,
        status_color: call.status_color,
        type: call.type,
        updated_at: call.updated_at,
        user_name: call.user_name,
        value: call.value
      })),
      calls_count: item.calls_count,
      contacts: item.contacts,
      cpf_cnpj: item.cpf_cnpj,
      gender: item.gender,
      id: item.id,
      name: item.name,
      photo: item.photo,
      sales_count: item.sales_count
    }));
    yield put(BuscaClienteActions.buscaClienteActionSuccess(dataPayload));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/buscaCliente.js